<template>
  <q-select
    v-model="addInput"
    transition-duration="100"
    placeholder="Add by name or tag"
    outlined
    flat
    dense
    use-input
    hide-selected
    hide-dropdown-icon
    input-debounce="0"
    :options="addOptions"
    @filter="addFilterFnc"
    @update:model-value="addRowClicked"
  >
    <template #prepend>
      <q-icon name="add" />
    </template>
    <template #option="scope">
      <q-list>
        <q-separator />
        <q-item v-ripple clickable bordered v-bind="scope.itemProps">
          <q-item-section>
            <q-item-label>
              {{ scope.opt.label }}
            </q-item-label>
            <q-item-label>
              <q-badge
                v-if="scope.opt.user_id"
                class="q-mr-sm"
                outline
                :color="$q.dark.isActive ? 'grey-4' : 'grey-9'"
                :label="'Owner: ' + userToName(getUser(scope.opt.user_id))"
              />
            </q-item-label>
          </q-item-section>
          <q-item-label side class="q-my-auto">
            <q-icon :name="scope.opt.type === 'tag' ? 'label' : 'assessment'" />
          </q-item-label>
        </q-item>
      </q-list>
    </template>
  </q-select>
</template>

<script lang="ts">
import { useUserStore } from '@/stores/user'
import type { OrganizationAttributes } from 'common'
import { usePropertyReportStore } from '@/stores/propertyreport'
import { userToName } from '@/utils'

export default {
  name: 'PropertyReportSearch',
  props: {
    reportIds: {
      required: true,
      type: Array<number>
    }
  },
  emits: ['add'],
  data() {
    return {
      userToName,
      addInput: '' as string,
      addOptions: [] as { label: string; type: 'report' | 'tag'; id: number }[]
    }
  },
  computed: {
    organization(): OrganizationAttributes | null {
      return useUserStore().organization
    },
    activeSubscriptions() {
      return usePropertyReportStore().activeAdminSubscriptions
    }
  },
  methods: {
    addAccess(id: number) {
      if (!this.reportIds.includes(id)) {
        this.$emit('add', id)
      }
    },
    addFilterFnc(val: string, update: (cbk: () => void) => void) {
      const reportTags = (this.organization?.report_tags || []).map((_) => ({
        type: 'tag' as 'report' | 'tag',
        label: _,
        id: -1,
        user_id: undefined as string | undefined
      }))
      const reportNames = this.activeSubscriptions
        .map((_) => ({
          type: 'report' as 'report' | 'tag',
          label: _.name,
          id: _.id!,
          user_id: _.user_id
        }))
        .filter((_) => !this.reportIds.includes(_.id))
      update(() => {
        if (val) {
          this.addOptions = reportTags
            .concat(reportNames)
            .filter((_) => _.label.toLowerCase().includes(val.toLowerCase()))
        } else {
          this.addOptions = []
        }
      })
    },
    addRowClicked(option: { label: string; type: 'report' | 'tag'; id: number }) {
      if (option.type === 'report') {
        this.addAccess(option.id)
      } else if (option.type === 'tag') {
        this.activeSubscriptions
          .filter((_) => _.tags.includes(option.label))
          .map((_) => _.id!)
          .forEach((id) => this.addAccess(id))
      }
      this.addInput = ''
    },
    getUser(id: string) {
      return useUserStore().peopleInOrgOrSharedPerId.get(id)
    }
  }
}
</script>
